import { render, staticRenderFns } from "./KitsFilterCard.vue?vue&type=template&id=454b12bd&"
import script from "./KitsFilterCard.vue?vue&type=script&lang=js&"
export * from "./KitsFilterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports